import { render, staticRenderFns } from "./addTaskDrawer.vue?vue&type=template&id=4d8cdb36&scoped=true&"
import script from "./addTaskDrawer.vue?vue&type=script&lang=js&"
export * from "./addTaskDrawer.vue?vue&type=script&lang=js&"
import style0 from "./addTaskDrawer.vue?vue&type=style&index=0&id=4d8cdb36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cdb36",
  null
  
)

export default component.exports